export var PlacePickerPresentationStyle;
(function (PlacePickerPresentationStyle) {
    PlacePickerPresentationStyle["modal"] = "modal";
    PlacePickerPresentationStyle["fullscreen"] = "fullscreen";
})(PlacePickerPresentationStyle || (PlacePickerPresentationStyle = {}));
//# sourceMappingURL=definitions.js.map